module.exports = __webpack_public_path__ + "resources/icon-comment.0f00d5e3786dca13.png";


//////////////////
// WEBPACK FOOTER
// ../src/component/post-footer/img/icon-comment.png
// module id = 844
// module chunks = 0 1